import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocaleStorageService {

  constructor() { }

  public saveData(key: string, value: string) {
    localStorage.setItem(environment.localstorage_prefix + key, value);
  }

  public getData(key: string) {
    return localStorage.getItem(environment.localstorage_prefix + key);
  }

  public removeData(key: string) {
    localStorage.removeItem(environment.localstorage_prefix + key);
  }

  public clearData() {
    Object.keys(localStorage).forEach(function(key){
      if (key.startsWith(environment.localstorage_prefix))
      {
        localStorage.removeItem(key);

      }
   });


  }

}
